import { get, set, del, createStore, clear, keys } from 'idb-keyval';
import { storageErrorTracker } from '../new_arch/services/storage/StorageErrorTracker';

function createIndexDBStorage( dbName: string ) {
	const store = createStore( dbName, dbName );

	return {
		setItem(
			key: string,
			value: string,
			callback?: ( error?: Error ) => void
		): Promise<void> {
			return storageErrorTracker.wrapIndexedDBOperation(
				() => set( key, value, store ),
				dbName,
				'write'
			)
				.then( () => callback?.() )
				.catch( error => callback?.( error ) );
		},

		getItem(
			key: string,
			callback?: ( error?: Error, result?: string ) => void
		): Promise<string | undefined> {
			return storageErrorTracker.wrapIndexedDBOperation(
				() => get<string>( key, store ),
				dbName,
				'read'
			)
				.then( ( value ) => {
					callback?.( undefined, value );
					return value;
				} )
				.catch( ( error ) => {
					callback?.( error );
					return undefined;
				} )
		},

		removeItem(
			key: string,
			callback?: ( error?: Error ) => void
		): Promise<undefined> {
			return storageErrorTracker.wrapIndexedDBOperation(
				() => del( key, store ),
				dbName,
				'delete'
			)
				.then( () => callback?.() )
				.catch( error => callback?.( error ) )
				.then( () => undefined );
		},

		getAllKeys(
			callback?: ( error?: Error, keys?: Array<string> ) => void
		): Promise<string[] | undefined> {
			return storageErrorTracker.wrapIndexedDBOperation(
				() => keys( store ),
				dbName,
				'read'
			)
				.then( ( allKeys ) => {
					callback?.( undefined, allKeys as string[] );
					return allKeys as string[];
				} )
				.catch( ( error ) => {
					callback?.( error );
					return undefined;
				} );
		},

		clear( callback?: ( error?: Error ) => void ): Promise<boolean> {
			return storageErrorTracker.wrapIndexedDBOperation(
				() => clear( store ),
				dbName,
				'delete'
			)
				.then( () => { callback?.(); return true; } )
				.catch( ( error ) => { callback?.( error ); return false; } );
		}
	};
}

export default createIndexDBStorage;
